export default __webpack_public_path__ + "static/2-22cd51c0682ac031cf4d8cab31846580.jpeg";